import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { useDeleteUser } from "@/api/user.api";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";

type DeleteUserModalProps = {
  userId: string;
  open: boolean;
  onClose: () => void;
};

export const DeleteUserModal = ({ userId, open, onClose }: DeleteUserModalProps) => {
  const { t } = useTranslation(["boClients", "common"]);
  const { mutateAsync: deleteUser, isPending } = useDeleteUser();

  const handleConfirm = async () => {
    await deleteUser(userId);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="sm"
      dismissible={!isPending}
      title={t("profileDeleteUserModal.title")}
      description={t("profileDeleteUserModal.description")}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isPending}
            className="flex-1"
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleConfirm}
            disabled={isPending}
            className="flex-1"
          >
            {isPending ? <Loader2 className="animate-spin" /> : t("profileDeleteUserModal.submit")}
          </Button>
        </div>
      }
    />
  );
};
